import { Fragment, JSX } from "react";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import IconButton from "@mui/material/IconButton";
import {
  useCsAttribute,
  useSubstructureApi,
  useSubstructureMeta,
} from "@plansoft-configuration-renderer/framework";

/**
 * Adds a new subconfiguration instance to the current configuration attribute.
 * @returns
 */
export function CustomSubstructureAddButton(): JSX.Element {
  const attribute = useCsAttribute();
  const { addSubCfgObject } = useSubstructureApi();
  const { canAdd } = useSubstructureMeta();
  return (
    <Fragment>
      {canAdd && (
        <IconButton
          onClick={() => addSubCfgObject({ path: attribute.path })}
          sx={{ color: "primary.main", fontSize: 36, ml: 0, pl: 0 }}
        >
          <AddCircleOutlineIcon fontSize="inherit" />
        </IconButton>
      )}
    </Fragment>
  );
}

CustomSubstructureAddButton.displayName = "CustomSubstructureAddButton";
